// extracted by mini-css-extract-plugin
module.exports = {"inputLabel":"styles_inputLabel__IiNcT","inputLabelHidden":"styles_inputLabelHidden__2P6Yn"};